import i18next from "i18next"
import { ScreenCode } from "../constants/path"

import Common from "./en/common.json"
import Profile from "./en/profile.json"
import Task from "./en/task.json"
import Communication from "./en/communication.json"
import MyCommunication from "./en/my_communication.json"

export const appLangBundles = {
  dnt: Common,
  [`screen_${ScreenCode.MY_PROFILE}`]: Profile,
  [`screen_${ScreenCode.CREATE_TASK}`]: Task,
  [`screen_${ScreenCode.TASK_DETAIL}`]: Task,
  [`screen_${ScreenCode.CREATE_COMMUNICATION}`]: Communication,
  [`screen_${ScreenCode.COMMUNICATION_DETAIL}`]: Communication,
  [`screen_${ScreenCode.MY_COMMUNICATIONS}`]: MyCommunication,
}
export const initI18n = () => {
  Object.keys(appLangBundles).forEach(v => {
    i18next.addResourceBundle("en", v, appLangBundles[v])
  })
  // i18next.addResourceBundle("en", "dnt", Common)
  // i18next.addResourceBundle("en", `screen_${ScreenCode.MY_PROFILE}`, Profile)
  // i18next.addResourceBundle("en", `screen_${ScreenCode.CREATE_TASK}`, Task)
  // i18next.addResourceBundle("en", `screen_${ScreenCode.TASK_DETAIL}`, Task)
  // i18next.addResourceBundle(
  //   "en",
  //   `screen_${ScreenCode.CREATE_COMMUNICATION}`,
  //   Communication
  // )
}
